import { useState, useEffect } from 'react'
import { Drawer, Tabs, Typography, Spin, Modal, Empty } from 'antd'
import styled from 'styled-components'
import { SignTitle } from '@/components/sign-title'
import { IconFont, SvgIcon, TagDetail } from '@/components'
import MarkdownEditor from '@/components/markdown-editor'
import emptyImg from '@/assets/imges/Empty/Empty.png'
import attachmentDelete from '@/assets/imges/attachment-delete.png'
import { useResultResourceEmailDetail } from './utils'
import DetailLog from './detail-log'
import { t } from '@/i18n'

export const DetailDrawer = props => {
  const {
    visible = true,
    onClose,
    dataList,
    logList = [],
    loading,
    resourceType,
    attackTypeList,
  } = props

  const [resultResourceEmailDetail, getResultResourceEmailDetail] = useResultResourceEmailDetail()

  const [emailDetailVisible, setEmailDetailVisible] = useState(false)

  useEffect(() => {
    if (dataList?.id) {
      getResultResourceEmailDetail({ id: dataList?.id }).catch(_ => {})
    }
  }, [dataList?.id])

  const BasicInfo = () => (
    <DetailDrawerBox>
      {loading ? (
        <Spin />
      ) : (
        <>
          <div className="flex">
            <p className="title">{t('用例名称：')}</p>
            <div style={{ width: 'calc(100% - 120px)', wordBreak: 'break-all' }}>
              <Typography.Text ellipsis={{ tooltip: true }}>{dataList?.case_name}</Typography.Text>
            </div>
          </div>
          <div className="flex">
            <p className="title">{t('验证模式：')}</p>
            <p className="name">
              {t('平台')} → {t('邮箱')}
            </p>
          </div>
          {dataList?.resource_tag_list && dataList?.resource_tag_list?.length > 0 && (
            <TagDetail resourceTagList={dataList?.resource_tag_list || []} />
          )}
          <div className="flex" style={{ width: '100%' }}>
            <p className="title">{resourceType === 8 ? t('附件：') : 'URL：'}</p>
            <div style={{ width: 'calc(100% - 120px)', wordBreak: 'break-all' }}>
              {resourceType === 8 &&
                dataList?.email_type === 1 &&
                `${dataList?.resource_name} (${t('不加密')})`}
              {resourceType === 8 &&
                dataList?.email_type === 2 &&
                `${dataList?.resource_name} (${t('复杂加密')})`}
              {resourceType === 8 &&
                dataList?.email_type === 3 &&
                `${dataList?.resource_name} (${t('有分卷')})`}
              {resourceType === 8 && dataList?.email_type === 4 && `${dataList?.resource_name}`}
              {resourceType === 7 && (
                <span>
                  <Typography.Text ellipsis={{ tooltip: true }}>
                    {dataList?.resource_name}
                  </Typography.Text>
                </span>
              )}
            </div>
          </div>
          <div className="flex">
            <p className="title">{t('模板名称：')}</p>
            <div>{dataList?.template_name}</div>
          </div>
          <div className="flex">
            <p className="title">{t('验证结果：')}</p>
            {dataList?.intercept_status === 1 && <div className="intercept">{t('拦截成功')}</div>}
            {dataList?.intercept_status === 2 && (
              <div className="intercept intercept-err">{t('防护失效')}</div>
            )}
            {dataList?.intercept_status === 3 && (
              <div
                className="intercept-err intercept"
                style={{ color: '#72b851', background: '#e9f5e3' }}
              >
                {t('检测成功')}
              </div>
            )}
            {dataList?.intercept_from === 'interception_from_manual_correct' && (
              <span
                style={{
                  marginLeft: 5,
                  borderRadius: 6,
                  padding: '0 2px',
                  fontSize: 12,
                  color: '#1bbc40',
                  background: '#d9f4df',
                  height: 20,
                  lineHeight: '20px',
                }}
              >
                {t('已修正')}
              </span>
            )}
          </div>
          <div className="flex">
            <p className="title">{t('危险等级：')}</p>
            {dataList?.risk_level === 1 && t('低危')}
            {dataList?.risk_level === 2 && t('中危')}
            {dataList?.risk_level === 3 && t('高危')}
            {dataList?.risk_level === 4 && t('严重')}
          </div>
          <div className="flex">
            <p className="title">{t('攻击类型：')}</p>
            <p className="name">
              {attackTypeList?.find(item => item?.id === String(dataList?.attack_type))?.name ||
                '-'}
            </p>
          </div>
          <div className="flex">
            <p className="title">{t('攻击组织')}:</p>
            <p className="name">{dataList?.apt_name || '-'}</p>
          </div>
          {dataList?.tactic_list && (
            <div className="flex">
              <p className="title" style={{ width: '105px' }}>
                {t('ATT&CK')}:
              </p>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: 'calc(100% - 110px)',
                }}
              >
                {dataList?.tactic_list.length > 0
                  ? dataList?.tactic_list?.map((item, index) => (
                      <div key={index}>
                        <a
                          href={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${item?.url}`}
                          style={{
                            width: '300px',
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item?.name}
                        </a>
                      </div>
                    ))
                  : '-'}
              </div>
            </div>
          )}
          {resourceType === 8 && (
            <>
              <div className="flex">
                <p className="title">{t('附件类型')}:</p>
                <Typography.Text
                  className="name"
                  ellipsis={{
                    tooltip:
                      (dataList?.attachment_type === 1 && t('office文档')) ||
                      (dataList?.attachment_type === 2 && t('脚本文件')) ||
                      (dataList?.attachment_type === 3 && t('PE可执行文件')) ||
                      (dataList?.attachment_type === 4 && t('可执行与可链接格式')) ||
                      (dataList?.attachment_type === 5 && t('日历文件')) ||
                      (dataList?.attachment_type === 6 && t('网页文件')) ||
                      (dataList?.attachment_type === 7 && t('压缩文件')),
                  }}
                >
                  {dataList?.attachment_type === 1 && t('office文档')}
                  {dataList?.attachment_type === 2 && t('脚本文件')}
                  {dataList?.attachment_type === 3 && t('PE可执行文件')}
                  {dataList?.attachment_type === 4 && t('可执行与可链接格式')}
                  {dataList?.attachment_type === 5 && t('日历文件')}
                  {dataList?.attachment_type === 6 && t('网页文件')}
                  {dataList?.attachment_type === 7 && t('压缩文件')}
                </Typography.Text>
              </div>
              <div className="flex">
                <p className="title">{t('操作系统')}:</p>
                {dataList.os === 1 && t('通用')}
                {dataList.os === 2 && 'Windows'}
                {dataList.os === 3 && 'Linux'}
                {dataList.os === 4 && 'Mac'}
              </div>
            </>
          )}

          {dataList?.describe && (
            <div className="block">
              <p className="title">{t('用例描述：')}</p>
              <MarkdownEditor
                isEdit={false}
                onlyDisplay
                setValue={() => {}}
                value={dataList?.describe}
              />
            </div>
          )}

          {dataList?.solution && (
            <div className="block">
              <p className="title">{t('解决方案：')}</p>
              <MarkdownEditor
                isEdit={false}
                onlyDisplay
                setValue={() => {}}
                value={dataList?.solution}
              />
            </div>
          )}
          <Modal
            visible={emailDetailVisible}
            footer={[]}
            title={<SignTitle show>{t('邮件详情')}</SignTitle>}
            onCancel={() => setEmailDetailVisible(false)}
            centered
          >
            <EmailDetail>
              <div className="flex">
                <div className="title">{t('邮件主题：')}</div>
                <div className="text">{resultResourceEmailDetail?.subject}</div>
              </div>
              <Separator style={{ marginTop: 10 }} />
              <div className="flex">
                <div className="title">{t('邮件内容：')}</div>
              </div>
              <div className="text" style={{ color: '#666666', marginTop: 6 }}>
                {JSON.stringify(resultResourceEmailDetail?.body)}
              </div>
              <Separator style={{ marginTop: 24 }} />
              <div>
                <div className="title">{t('附件')}</div>
                <div>
                  {resultResourceEmailDetail?.attach_list?.map(item => (
                    <div key={item}>
                      <IconFont type="icon-047-file" style={{ marginRight: 10, marginTop: 10 }} />
                      {t('附件')}：{item}
                    </div>
                  ))}
                </div>
              </div>
            </EmailDetail>
          </Modal>
        </>
      )}
    </DetailDrawerBox>
  )

  const AttackDetail = () => (
    <DetailDrawerBox>
      {loading ? (
        <Spin />
      ) : (
        <>
          {resourceType === 8 && (
            <div className="flex">
              <div className="title">{t('渗透路径')}</div>
              {dataList?.path?.split('-')?.length > 2 ? (
                <div
                  style={{
                    position: 'relative',
                    height: 100 + 40 * 2,
                    paddingLeft: 120,
                    width: 'calc(100% - 110px)',
                  }}
                >
                  {dataList?.path?.split('-')?.map((item, index) => (
                    <div
                      key={index}
                      className="seepage"
                      style={{
                        width: 160 - 30 * (index + 1),
                        height: 160 - 30 * (index + 1),
                        zIndex: 10 + index,
                        background: index === 0 ? '#6F9FFF' : index === 1 ? '#A7C4FF' : '#E0EAFF',
                      }}
                    >
                      <span
                        className="seepage-title"
                        style={{
                          color:
                            index === dataList?.path?.split('-').length - 1 ? '#2973FF' : '#fff',
                          height: '24px',
                          lineHeight: '24px',
                        }}
                      >
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  style={{
                    position: 'relative',
                    height: 140,
                    paddingLeft: 120,
                    width: 'calc(100% - 110px)',
                  }}
                >
                  <div
                    className="seepage"
                    style={{
                      width: 100,
                      height: 100,
                      zIndex: 12,
                      background: '#6F9FFF',
                    }}
                  >
                    <span
                      className="seepage-title"
                      style={{
                        color: '#fff',
                        height: '24px',
                        lineHeight: '24px',
                      }}
                    >
                      {dataList?.path?.split('-')[0]}
                    </span>
                  </div>
                  {dataList?.path?.split('-').length > 1 && (
                    <div
                      className="seepage"
                      style={{
                        width: 64,
                        height: 64,
                        zIndex: 13,
                        background: '#E0EAFF',
                      }}
                    >
                      <span
                        className="seepage-title"
                        style={{
                          color: '#2973FF',
                          height: '24px',
                          lineHeight: '24px',
                        }}
                      >
                        {dataList?.path?.split('-')[1]}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          <Separator />

          <div className="flex">
            <div style={{ width: '100%' }}>
              <div className="send">{t('发送')}</div>
              <br />
              {resourceType === 8
                ? dataList?.send_hash && (
                    <div className="hash">
                      {Object.keys(JSON.parse(dataList?.send_hash)).map(item => (
                        <div key={item}>
                          <div className="name">
                            <IconFont
                              type={'icon-047-file'}
                              style={{ fontSize: 16, marginRight: 8 }}
                            />
                            <span style={{ color: '#666' }}> {item || '-'}</span>
                          </div>
                          <div className="flex" style={{ marginTop: 10 }}>
                            <div className="hash-title">SHA-256:</div>
                            <div className="hash-text">
                              {JSON.parse(dataList?.send_hash)[item]?.['SHA-256']}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )
                : dataList?.send_body && (
                    <div className="hash">
                      <div
                        className="flex"
                        style={{
                          borderBottom: '1px solid #EAEDF1',
                          margin: 0,
                          paddingBottom: 10,
                        }}
                      >
                        <div className="title" style={{ color: '#333' }}>
                          {t('邮件主题')}:
                        </div>
                        <div className="text">{dataList?.send_subject}</div>
                      </div>
                      <div
                        className="title"
                        style={{ color: '#333', marginBottom: 10, marginTop: 10 }}
                      >
                        {t('邮件内容')}:
                      </div>
                      <div className="text">{dataList?.send_body}</div>
                    </div>
                  )}

              {dataList?.received_body && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div className="send">{t('接收')}</div>
                </div>
              )}

              {dataList?.received_body &&
                (resourceType === 8 ? (
                  dataList?.send_hash && (
                    <>
                      <div className="hash">
                        {Object.keys(JSON.parse(dataList?.received_hash)).map(item => (
                          <div key={item}>
                            <div className="name">
                              <IconFont
                                type={'icon-047-file'}
                                style={{ fontSize: 16, marginRight: 8 }}
                              />
                              <span style={{ color: '#666' }}> {item || '-'}</span>
                            </div>
                            {Object.keys(JSON.parse(dataList?.received_hash))?.includes(item) ? (
                              <div className="flex" style={{ marginTop: 10 }}>
                                <div className="hash-title">SHA-256:</div>
                                <div className="hash-text">
                                  {JSON.parse(dataList?.received_hash)[item]?.['SHA-256']}
                                </div>
                              </div>
                            ) : (
                              <Empty image={attachmentDelete} description={t('附件已被删除')} />
                            )}
                          </div>
                        ))}
                      </div>

                      <EmailDetail>
                        <div className="flex">
                          <div className="title">{t('邮件主题：')}</div>
                          <div className="text">{resultResourceEmailDetail?.subject}</div>
                        </div>
                        <Separator style={{ marginTop: 10 }} />
                        <div className="flex">
                          <div className="title">{t('邮件内容：')}</div>
                        </div>
                        <div className="text" style={{ color: '#666666', marginTop: 6 }}>
                          {JSON.stringify(resultResourceEmailDetail?.body)}
                        </div>
                        <Separator style={{ marginTop: 24 }} />
                        <div>
                          <div className="title">{t('附件')}</div>
                          <div>
                            {resultResourceEmailDetail?.attach_list?.map(item => (
                              <div key={item}>
                                <IconFont
                                  type="icon-047-file"
                                  style={{ marginRight: 10, marginTop: 10 }}
                                />
                                {t('附件')}：{item}
                              </div>
                            ))}
                          </div>
                        </div>
                      </EmailDetail>
                    </>
                  )
                ) : dataList?.received_body ? (
                  <div className="hash">
                    <div
                      className="flex"
                      style={{
                        borderBottom: '1px solid #EAEDF1',
                        paddingBottom: 10,
                      }}
                    >
                      <div className="title" style={{ color: '#333' }}>
                        {t('邮件主题')}
                      </div>
                      <div className="text">{dataList?.received_subject}</div>
                    </div>
                    <div className="title" style={{ color: '#333', marginBottom: 10 }}>
                      邮件内容:
                    </div>
                    <div className="text"> {dataList?.send_body}</div>
                  </div>
                ) : (
                  <Empty image={emptyImg} />
                ))}
            </div>
          </div>
        </>
      )}
    </DetailDrawerBox>
  )

  const LogDetail = () => (
    <DetailDrawerBox>
      {loading ? (
        <Spin />
      ) : (
        <div className="log-alarm">
          <div className="log-alarm-title">{t('告警日志：')}</div>
          {logList?.map((item, index) => (
            <DetailLog index={index} data={item} key={index} dataList={dataList} />
          ))}
        </div>
      )}
    </DetailDrawerBox>
  )

  return (
    <DetailDrawerContainer>
      <Drawer
        title={<SignTitle show>{t('用例详情')}</SignTitle>}
        placement="right"
        closable
        onClose={onClose}
        visible={visible}
        width={600}
        destroyOnClose
      >
        <Tabs
          defaultActiveKey="1"
          items={
            logList.length > 0
              ? [
                  { label: t('用例信息'), key: '1', children: <BasicInfo /> },
                  { label: t('攻击详情'), key: '2', children: <AttackDetail /> },
                  { label: t('告警日志'), key: '3', children: <LogDetail /> },
                ]
              : [
                  { label: t('用例信息'), key: '1', children: <BasicInfo /> },
                  { label: t('攻击详情'), key: '2', children: <AttackDetail /> },
                ]
          }
        />
      </Drawer>
    </DetailDrawerContainer>
  )
}

const DetailDrawerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const DetailDrawerBox = styled.div`
  .block {
    margin: 12px 0;
    .title {
      font-size: 14px;
      color: #86909c;
      line-height: 16px;
      width: 92px;
      text-align: left;
      margin-right: 18px;
      white-space: nowrap;
    }
  }
  .seepage {
    background-color: #6f9fff;
    border-radius: 50%;
    margin-top: 32px;
    transform: translateX(-50%);
    left: 50%;
    position: absolute;
    bottom: 0;
  }
  .seepage-center {
    display: flex;
    width: 100px;
    height: 100px;
    justify-content: center;
    align-items: center;
    background-color: #6f9fff;
    border-radius: 50%;
    left: 50%;
    position: absolute;
    bottom: 0;
    transform: translateX(-50%);
  }
  .seepage-exe {
    width: 64px;
    height: 64px;
    display: block;
    z-index: 100;
    background-color: #e0eaff;
    border-radius: 50%;
    left: 50%;
    position: absolute;
    bottom: 0;
    transform: translateX(-50%);
  }
  .seepage-title {
    text-align: center;
    display: block;
    margin-top: 10px;
  }
  .hash-text {
    width: calc(100% - 80px);
    word-break: break-all;
    color: #666;
  }
  .hash-title {
    width: 80px;
  }
  .intercept,
  .intercept-err {
    width: 64px;
    height: 20px;
    background: #e5eeff;
    border-radius: 4px 12px 4px 12px;
    font-size: 12px;
    color: #2973ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .intercept-err {
    color: #f44f4f;
    background: #fde5e5;
  }
  .detect-success {
    color: #666666;
    background: #d9d9d9;
  }
  .content {
    word-break: break-all;
    color: #666666;
    border-radius: 4px;
    .headers {
      display: flex;
      margin-bottom: 5px;
    }
    .marked {
      white-space: nowrap;
      color: #558490;
      margin-right: 5px;
    }
    .marked-body {
      color: #558490;
    }
  }
  .header {
    // max-height: 200px;
    overflow-y: auto;
  }
  .flex,
  .flex-name {
    display: flex;
    margin-bottom: 24px;
    .content {
      color: #666666;
      border-radius: 4px;
      padding: 0 10px;
      width: calc(98% - 128px);
      background: #f7f8fa;
    }
    .title {
      height: 14px;
      font-size: 14px;
      color: #86909c;
      line-height: 16px;
      width: 92px;
      text-align: left;
      margin-right: 18px;
      white-space: nowrap;
      margin-bottom: 0px;
    }
    .name {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .hash {
    padding: 12px;
    width: 100%;
    background-color: #f8f9fb;
    border-radius: 6px;
    margin: 10px 0;
    .text {
      word-break: break-all;
      width: 100%;
    }
  }
  .waf {
    display: inline-block;
    padding: 5px 10px;
    color: #9791ff;
    font-size: 12px;
    background-color: #f0efff;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 4px;
  }
  .send {
    font-size: 12px;
    padding: 3px;
    display: inline-block;
    border-radius: 3px;
    border: 1px solid #999999;
  }
  .text {
    word-break: break-all;
    word-wrap: break-word;
    white-space: pre-wrap;
    margin-right: 10px;
    color: #666;
  }
  .flex-name {
    width: 50%;
  }
  .flex-two {
    display: flex;
    .title {
      height: 14px;
      font-size: 14px;
      color: #86909c;
      line-height: 16px;
      width: 92px;
      text-align: left;
      margin-right: 18px;
      white-space: nowrap;
    }

    .name {
      width: 55%;
    }
  }
  .params {
    width: 100%;
    background: #f8f9fb;
    border-radius: 6px;
    padding: 12px;
    margin-top: 8px;
    .sample {
      border-top: 1px dashed #d5d9dd;
      padding: 10px;
      &:first-child {
        border: 0;
      }
    }
  }
  .params-flex {
    display: flex;
  }
  .params-title {
    height: 20px;
    width: 106px;
  }
`

const Separator = styled.div`
  width: 98%;
  height: 1px;
  border-bottom: 1px dashed #eaedf1;
  margin-bottom: 16px;
`
const SvgOs = styled(SvgIcon)`
  width: 32px;
  height: 32px;
  margin-right: 10px;
`

const EmailDetail = styled.div`
  background: #f8f9fb;
  padding: 10px;
  border-radius: 6px;
  .flex {
    display: flex;
  }
  .title {
    width: 70px;
  }
  .text {
    flex: 1;
    word-break: break-all;
  }
`
